import React, { useContext, useState } from "react";
import { Badge, Button, ColorPicker, Form, Input, Upload, message } from "antd";
import ModalTags from "./../GeoUnit/ModalTags";
import { IconPicker } from "react-fa-icon-picker";
import { context } from "../../context/context";
import { http } from "../../services/httpService";
import config from "../../services/config.json";
import { toast } from "react-toastify";
import { UploadOutlined } from "@ant-design/icons";
import ImgCrop from "antd-img-crop";

const ContentForm = () => {
    const {
        placeIcon,
        setPlaceIcon,
        placeName,
        setPlaceName,
        placeTag,
        setIsModalOpen,
        setForceUpdate,
        setPlaceMapIcon,
        placeMapIcon,
        isEditShow,
        placeColor,
        setPlaceColor,
        placeId,
        setIsEditShow,
        isAddSubset,
        child,
        placeCategories,
        fileList,
        setFileList,
    } = useContext(context);
    // state
    const [coverPic, setCoverPic] = useState("");

    const handleColorChange = (color) => {
        setPlaceColor(color);
    };
    const [form] = Form.useForm();
    const onFinish = () => {
        const name = form.getFieldValue("عنوان");
        const color = document.querySelector(
            ".ant-color-picker-trigger-text"
        ).innerText;

        const parentId = placeCategories.map((p) => {
            if (p.children.includes(child)) return p._id;
        });

        setIsModalOpen(false);
        // api
        if (!isEditShow && !isAddSubset) {
            http.post(`${config.parkopoloApi}/api/Category/category`, {
                name,
                tag: placeTag,
                color,
                icon: placeIcon,
                mapIcon: placeMapIcon,
                coverPic,
                kind: "Content",
            })
                .then((res) => {
                    setForceUpdate(7);
                    console.log(res.data.success);
                    toast.success("دسته با موفقیت ساخته شد !", {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        progress: undefined,
                        theme: "colored",
                        style: { fontFamily: "Vazir" },
                    });
                })
                .catch((err) => {
                    console.log(err);
                    toast.error(" خطایی رخ داد !", {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        progress: undefined,
                        theme: "colored",
                        style: { fontFamily: "Vazir" },
                    });
                });
        } else if (isEditShow && !isAddSubset) {
            http.post(`${config.parkopoloApi}/api/Category/editCategory`, {
                categoryId: placeId,
                name: name,
                tag: placeTag,
                color: color,
                icon: placeIcon,
                mapIcon: placeMapIcon,
                coverPic,
            })
                .then((res) => {
                    setForceUpdate(6);
                    setIsEditShow(false);
                    console.log(res.data.success);
                    toast.success(" دسته با موفقیت ویرایش شد !", {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        progress: undefined,
                        theme: "colored",
                        style: { fontFamily: "Vazir" },
                    });
                })
                .catch((err) => {
                    setIsEditShow(false);
                    toast.error(" خطایی رخ داد !", {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        progress: undefined,
                        theme: "colored",
                        style: { fontFamily: "Vazir" },
                    });
                    console.log(err);
                });
        } else if (!isEditShow && isAddSubset) {
            http.post(`${config.parkopoloApi}/api/Category/subCategory`, {
                categoryId: placeId,
                name: name,
                tag: placeTag,
                color: color,
                icon: placeIcon,
                coverPic,
            })
                .then((res) => {
                    setForceUpdate(78);
                    toast.success(" زیردسته با موفقیت ساخته شد !", {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        progress: undefined,
                        theme: "colored",
                        style: { fontFamily: "Vazir" },
                    });
                })
                .catch((err) => {
                    toast.error(" خطایی رخ داد !", {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        progress: undefined,
                        theme: "colored",
                        style: { fontFamily: "Vazir" },
                    });
                    console.log(err);
                });
        } else if (isEditShow && isAddSubset) {
            http.post(`${config.parkopoloApi}/api/Category/editSubCategory`, {
                categoryId: parentId,
                subcategoryId: child._id,
                name: name,
                tag: placeTag,
                color: color,
                icon: placeIcon,
                coverPic,
            })
                .then((res) => {
                    setForceUpdate(78);
                    toast.success(" زیردسته با موفقیت ویرایش شد !", {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        progress: undefined,
                        theme: "colored",
                        style: { fontFamily: "Vazir" },
                    });
                })
                .catch((err) => {
                    toast.error(" خطایی رخ داد !", {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        progress: undefined,
                        theme: "colored",
                        style: { fontFamily: "Vazir" },
                    });
                    console.log(err);
                });
        }
        setCoverPic();
        setForceUpdate(58);
    };
    const handleInputChange = (e) => {
        setPlaceName(e.target.value);
    };
    const handleIconChange = (e) => {
        setPlaceIcon(e);
    };
    const handleMapIconChange = (e) => {
        setPlaceMapIcon(e);
    };
    //     http.post(
    //         `${config.parkopoloApi}/api/FileManager/multipleChoices/false/Image`,
    //         {
    //             macAddress: `${fpHash}`,
    //         }
    //     )
    //         .then((res) => {
    //             console.log(res.data);
    //         })
    //         .catch((err) => {
    //             console.log(err);
    //         });
    // };
    const props = {
        name: "objectKey",
        action: `${config.parkopoloApi}/api/FileManager/uploadFile/?parentId=65786b323141c77220f40944`,
        headers: {
            authorization: "authorization-text",
        },
        onChange(info) {
            setFileList(info.fileList);
            if (info.file.status === "done") {
                message.success(`${info.file.name} فایل با موفقیت آپلود شد`);
                setCoverPic(info.file.response.files[0]._id);
            } else if (info.file.status === "error") {
                message.error(` در آپلود فایل خطایی رخ داد!`);
            }
        },
    };
    return (
        <Form form={form} name="control-hooks" onFinish={onFinish}>
            <Form.Item
                rules={[
                    {
                        required: true,
                    },
                ]}
                name="عنوان"
            >
                <div className="nameInput">
                    <Badge.Ribbon placement="start" text="عنوان">
                        <Input
                            value={placeName}
                            style={{ paddingRight: "45px", marginTop: "15px" }}
                            placeholder="عنوان را وارد کنید"
                            onChange={handleInputChange}
                        />
                    </Badge.Ribbon>
                </div>
            </Form.Item>

            <Form.Item name="تگ">
                <div>
                    <Badge.Ribbon placement="start" text="تگ(ها)">
                        <ModalTags section="placeCategories" />
                    </Badge.Ribbon>
                </div>
            </Form.Item>

            <div>
                <div>
                    <Form.Item name="آیکون">
                        <Badge.Ribbon placement="start" text="آیکون">
                            <IconPicker
                                value={placeIcon}
                                buttonStyles={{
                                    padding: "5px 65px 0 20px",
                                    border: "1px solid silver",
                                    width: "100%",
                                }}
                                onChange={(e) => handleIconChange(e)}
                            />
                        </Badge.Ribbon>
                    </Form.Item>
                    {/* {!isAddSubset ? (
                        <Form.Item name="آیکون نقشه">
                            <Badge.Ribbon placement="start" text="آیکون نقشه">
                                <IconPicker
                                    value={placeMapIcon}
                                    buttonStyles={{
                                        padding: "5px 95px 0 20px",
                                        border: "1px solid silver",
                                        width: "100%",
                                    }}
                                    onChange={(e) => handleMapIconChange(e)}
                                />
                            </Badge.Ribbon>
                        </Form.Item>
                    ) : null} */}
                </div>
                <Form.Item name="رنگ">
                    <Badge.Ribbon placement="start" text="انتخاب رنگ">
                        <ColorPicker
                            onChange={handleColorChange}
                            value={placeColor}
                            style={{
                                padding: "20px 85px 20px 10px",
                                width: "100%",
                            }}
                            showText
                        />
                    </Badge.Ribbon>
                </Form.Item>
            </div>

            <Form.Item
                rules={[
                    {
                        required: true,
                    },
                ]}
                name="عکس"
            >
                <div>
                    <Badge.Ribbon placement="start" text="انتخاب عکس">
                        <ImgCrop rotationSlider>
                            <Upload
                                fileList={fileList}
                                maxCount={1}
                                multiple={false}
                                {...props}
                            >
                                <Button
                                    icon={<UploadOutlined />}
                                    style={{
                                        paddingRight: "6rem",
                                    }}
                                >
                                    آپلود فایل
                                </Button>
                            </Upload>
                        </ImgCrop>
                    </Badge.Ribbon>
                </div>
            </Form.Item>
            <Form.Item>
                <div
                    style={{
                        display: "flex",
                        justifyContent: "center",
                    }}
                >
                    {isEditShow === true ? (
                        <Button type="primary" htmlType="submit">
                            ثبت ویرایش
                        </Button>
                    ) : (
                        <Button
                            // disabled={name === ""}
                            type="primary"
                            htmlType="submit"
                        >
                            ثبت
                        </Button>
                    )}
                </div>
            </Form.Item>
        </Form>
    );
};
export default ContentForm;
